import { useEffect } from "react";
import LorsForm from "@/components/landing/lors/LorsForm";
import { getOct22Copy } from "@/components/landing/lors/translationsOct22";
import { getNov19Copy } from "@/components/landing/lors/translationsNov19";
import { getDec17Copy } from "@/components/landing/lors/translationsDec17";
import { captureUtmsFromUrl } from "@/components/landing/lors/utmStorage";

const webinars = {
  oct22: { copy: getOct22Copy(null), redirectTo: "/october-22-2026/ty" },
  nov19: { copy: getNov19Copy(null), redirectTo: "/november-19-2026/ty" },
  dec17: { copy: getDec17Copy(null), redirectTo: "/december-17-2026/ty" },
};

const WebinarEmbed = ({ formKey }: { formKey: keyof typeof webinars }) => {
  useEffect(() => {
    captureUtmsFromUrl();
    const previousLang = document.documentElement.lang;
    const previousBackground = document.body.style.background;
    document.documentElement.lang = "en";
    document.body.style.background = "transparent";
    return () => {
      document.documentElement.lang = previousLang;
      document.body.style.background = previousBackground;
    };
  }, []);

  const webinar = webinars[formKey];
  return (
    <main className="lors-theme p-2">
      <LorsForm
        copy={webinar.copy}
        redirectTo={webinar.redirectTo}
        formKey={formKey}
        hideMeta
      />
    </main>
  );
};

export default WebinarEmbed;